function buildItemLink(projectId, languageCodename, itemId) {
    return `https://app.kontent.ai/goto/edit-item/project/${projectId}/variant-codename/${languageCodename}/item/${itemId}`;
}
export function buildElementLink(projectId, languageCodename, itemId, elementCodename) {
    return `${buildItemLink(projectId, languageCodename, itemId)}/element/${elementCodename}`;
}
export function buildComponentElementLink(projectId, languageCodename, itemId, contentComponentId, componentElementCodename) {
    return `${buildItemLink(projectId, languageCodename, itemId)}/component/${contentComponentId}/element/${componentElementCodename}`;
}
export function buildKontentLink(data) {
    if (data.contentComponentId) {
        return buildComponentElementLink(data.projectId, data.languageCodename, data.itemId, data.contentComponentId, data.elementCodename);
    }
    else {
        return buildElementLink(data.projectId, data.languageCodename, data.itemId, data.elementCodename);
    }
}
//# sourceMappingURL=link.js.map